import { SvgIcon } from "@/components/ui/SvgIcon";
import { CtaCardIcon } from "@/icons/CtaCardIcon";
import { IconInfoType } from "@/sections/FaqSections";
import { RichText } from "@/sections/RichText";
import React, { ReactNode } from "react";
import "./CardFaqCTA.scss";

export enum CardFaqCTAType {
  FAQ = "FAQ", //it has a title a description and a link
  CTA = "CTA", //it has a title and a link
  CTAICON = "CTAICON", //it has a title and a link
}

interface CardFaqCTAProps {
  type: CardFaqCTAType;
  title: string;
  description?: string | ReactNode;
  link: string;
  openModal?: CallableFunction;
  isExternal?: boolean;
  asLink?: "a" | React.ComponentType<any>;
  icon?: IconInfoType;
}

export const CardFaqCTA: React.FC<CardFaqCTAProps> = ({
  type = "Evento",
  title,
  description,
  link,
  openModal,
  isExternal,
  asLink = "a",
  icon,
}) => {
  const WrapComponent = type === CardFaqCTAType.FAQ ? "div" : asLink;
  const cardClass =
    type === CardFaqCTAType.FAQ
      ? "faq-card"
      : type === CardFaqCTAType.CTA
        ? "cta-card"
        : "cta-icon-card";
  const WrapComponentProps =
    type === CardFaqCTAType.FAQ
      ? {
          className: cardClass,
          onClick: openModal,
        }
      : {
          href: link,
          target: isExternal ? "_blank" : undefined,
          rel: isExternal ? "noopener noreferrer" : undefined,
          className: cardClass,
        };

  return (
    <WrapComponent {...WrapComponentProps}>
      <div className={`${cardClass}__header`}>
        <h1 className={`${cardClass}__title`}>{title}</h1>
      </div>
      {type === CardFaqCTAType.FAQ && description && (
        <div className={`${cardClass}__description`}>
          <RichText
            description={description}
            maxLines={6}
            useShowToggle={false}
          />
        </div>
      )}
      {type === CardFaqCTAType.CTAICON &&
        (icon ? (
          <SvgIcon icon={icon} className={`${cardClass}__icon`} />
        ) : (
          <CtaCardIcon className={`${cardClass}__icon`}></CtaCardIcon>
        ))}
    </WrapComponent>
  );
};
